// import React, {
//   useState,
//   useEffect,
//   createContext,
//   useContext,
//   useCallback,
// } from "react";
// import { getUser, signIn as sendSignInRequest } from "../api/auth";
// import { useNavigate, useLocation } from "react-router-dom";
// function RoleWiseAuth(myrole) {
//   if (myrole == "company") {
//     return [
//       {
//         text: "Dashboard",
//         path: "/adminDashboard",
//         icon: "ri-line-chart-line",
//       },
//       {
//         text: "Tickets",
//         path: "/ticket",
//         icon: "ri-coupon-line",
//       },
//       {
//         text: "Client",
//         path: "/client",
//         icon: "ri-user-add-line",
//       },
//       {
//         text: "Developer",
//         path: "/Developer",
//         icon: "ri-user-settings-line",
//       },
//       {
//         text: "Projects",
//         path: "/projects",
//         icon: "ri-folder-3-line",
//       },
//       {
//         text: "Configuration",
//         path: "/configuration",
//         icon: "ri-settings-3-line",
//       },
//       {
//         text: "Reports",
//         path: "/Reports",
//         icon: "ri-file-chart-line",
//       },
//       {
//         text: "Log Reports",
//         path: "/Log-Reports",
//         icon: "ri-database-line",
//       },
//     ];
//   } else if (myrole == "companyuser") {
//     return [
//       {
//         text: "Dashboard",
//         path: "/developerDashboard",
//         icon: "ri-line-chart-line",
//       },
//       {
//         text: "Tickets",
//         path: "/ticket",
//         icon: "ri-coupon-line",
//       },
//       {
//         text: "Reports",
//         path: "/Reports",
//         icon: "ri-file-chart-line",
//       },
//       {
//         text: "Log Reports",
//         path: "/Log-Reports",
//         icon: "ri-database-line",
//       },
//       {
//         text: "Configuration",
//         path: "/developer-configuration",
//         icon: "ri-equalizer-line",
//       },
//     ];
//   } else if (myrole == "customer") {
//     return [
//       {
//         text: "Dashboard",
//         path: "/customerDashboard",
//         icon: "ri-line-chart-line",
//       },
//       {
//         text: "Tickets",
//         path: "/ticket",
//         icon: "ri-coupon-line",
//       },
//       {
//         text: "Contact",
//         path: "/contact",
//         icon: "ri-contacts-line",
//       },
//       {
//         text: "Configuration",
//         path: "/client-configuration",
//         icon: "ri-equalizer-line",
//       },
//     ];
//   } else if (myrole === "customercontact") {
//     return [
//       {
//         text: "Dashboard",
//         path: "/custContactDash",
//         icon: "ri-line-chart-line",
//       },
//       {
//         text: "Tickets",
//         path: "/ticket",
//         icon: "ri-coupon-line",
//       },
//       {
//         text: "Configuration",
//         path: "/contact-configuration",
//         icon: "ri-equalizer-line",
//       },
//     ];
//   }
// }

// function AuthProvider(props) {
//   const [user, setUser] = useState();
//   const [loading, setLoading] = useState(true);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     (async function () {
//       const auth = localStorage.getItem("authState");
//       // sessionStorage.setItem("authState", auth);

//       if (!auth) {
//         setUser(undefined);
//         setLoading(false);
//         return;
//       }

//       const result = await getUser();

//       if (result.isOk) {
//         const localUser = JSON.parse(localStorage.getItem("authState"));

//         if (localUser?.email !== result.data.email) {
//           //  Mismatch → force logout
//           localStorage.removeItem("authState");
//           setUser(undefined);
//           window.location.replace("/");
//           return;
//         }
//         let userAuth = RoleWiseAuth(result.data.userrole);

//         setUser({
//           ...result.data,
//           userAuth: userAuth,
//         });
//         // REDIRECT BASED ON ROLE
//         const role = result.data.userrole;
//         //shreyasi's chnages
//         const currentPath = location.pathname;

//         if (currentPath === "/" || currentPath === "/login") {
//           if (role === "company")
//             navigate("/adminDashboard", { replace: true });
//           else if (role === "companyuser")
//             navigate("/developerDashboard", { replace: true });
//           else if (role === "customer")
//             navigate("/customerDashboard", { replace: true });
//           else if (role === "customercontact")
//             navigate("/custContactDash", { replace: true });
//         }
//       } else {
//         localStorage.removeItem("authState");
//         setUser(undefined);
//         window.location.replace("/");
//       }

//       setLoading(false);
//     })();
//   }, []);
//   // useEffect(() => {
//   //   const handleStorageChange = (event) => {
//   //     if (event.key === "authState") {
//   //       const auth = localStorage.getItem("authState");

//   //       if (!auth) {
//   //         // 🔴 Logout from another tab
//   //         setUser(undefined);
//   //       }
//   //     }
//   //   };

//   //   window.addEventListener("storage", handleStorageChange);

//   //   return () => {
//   //     window.removeEventListener("storage", handleStorageChange);
//   //   };
//   // }, []);

//   useEffect(() => {
//     const handleStorageChange = async (event) => {
//       if (event.key === "authState") {
//         const auth = localStorage.getItem("authState");

//         if (auth) {
//           // ✅ LOGIN happened in another tab → fetch full user again
//           const result = await getUser();

//           if (result.isOk) {
//             let userAuth = RoleWiseAuth(result.data.userrole);

//             setUser({
//               ...result.data,
//               userAuth: userAuth,
//             });
//           } else {
//             setUser(undefined);
//             window.location.replace("/");
//           }
//         } else {
//           // 🔴 LOGOUT happened
//           setUser(undefined);
//           window.location.replace("/");
//         }
//       }
//     };

//     window.addEventListener("storage", handleStorageChange);

//     return () => {
//       window.removeEventListener("storage", handleStorageChange);
//     };
//   }, []);

//   const signIn = useCallback(async (email, password) => {
//     const existingAuth = localStorage.getItem("authState");

//     if (existingAuth) {
//       const existingUser = JSON.parse(existingAuth);

//       if (existingUser.email !== email) {
//         return {
//           isOk: false,
//           message:
//             "Another user is already logged in this browser. Please logout first.",
//         };
//       }
//     }
//     const result = await sendSignInRequest(email, password);
//     if (result.isOk) {
//       setUser(result.data);
//       let userAuth = RoleWiseAuth(result.data.userrole);
//       setUser({
//         ...result.data,
//         userAuth: userAuth,
//       });

//       const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
//       const {
//         access_token,
//         login_name,
//         cmpusercode,
//         custcode,
//         contactcode,
//         companytransid,
//         customertransid,
//         contacttransid,
//         usertransid,
//         refresh_token,
//         email,
//         contactname,
//         username,
//         userrole,
//         custlogo,
//         contactlogo,
//         //// user logo here
//         userlogo,
//         companyavatar,
//       } = result.data;

//       const authData = {
//         access_token,
//         login_name,
//         cmpusercode,
//         custcode,
//         contactcode,
//         companytransid,
//         customertransid,
//         contacttransid,
//         usertransid,
//         refresh_token,
//         email,
//         contactname,
//         username,
//         userrole,
//         expirationTime,
//         custlogo,
//         userlogo,
//         contactlogo,
//         companyavatar,
//       };
//       // sessionStorage.setItem("authState", JSON.stringify(authData));
//       localStorage.setItem("authState", JSON.stringify(authData));
//       // sessionStorage.setItem("authState", JSON.stringify(authData));
//     }

//     return result;
//   }, []);

//   const signOut = useCallback(() => {
//     sessionStorage.removeItem("lastOpenedTicket");
//     sessionStorage.removeItem("authState");
//     // localStorage.clear();
//     localStorage.removeItem("authState");

//     window.dispatchEvent(new Event("storage"));
//     setUser(undefined);
//   }, []);

//   return (
//     <AuthContext.Provider
//       value={{
//         user,
//         signIn,
//         signOut,
//         loading,
//         setUser,
//         unreadCount,
//         setUnreadCount,
//       }}
//       {...props}
//     />
//   );
// }

// const AuthContext = createContext({ loading: false });
// const useAuth = () => useContext(AuthContext);

// export { AuthProvider, useAuth };

import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useCallback,
} from "react";
import { getUser, signIn as sendSignInRequest } from "../api/auth";
import { useNavigate, useLocation } from "react-router-dom";

// ✅ NEW: TOKEN VALIDATION FUNCTION
const isTokenValid = (auth) => {
  try {
    const parsed = JSON.parse(auth);

    if (!parsed?.access_token) return false;

    if (parsed.expirationTime && parsed.expirationTime < Date.now()) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

function RoleWiseAuth(myrole) {
  if (myrole == "company") {
    return [
      {
        text: "Dashboard",
        path: "/adminDashboard",
        icon: "ri-line-chart-line",
      },
      { text: "Tickets", path: "/ticket", icon: "ri-coupon-line" },
      { text: "Client", path: "/client", icon: "ri-user-add-line" },
      { text: "Developer", path: "/Developer", icon: "ri-user-settings-line" },
      { text: "Projects", path: "/projects", icon: "ri-folder-3-line" },
      {
        text: "Configuration",
        path: "/configuration",
        icon: "ri-settings-3-line",
      },
      { text: "Reports", path: "/Reports", icon: "ri-file-chart-line" },
      { text: "Log Reports", path: "/Log-Reports", icon: "ri-database-line" },
    ];
  } else if (myrole == "companyuser") {
    return [
      {
        text: "Dashboard",
        path: "/developerDashboard",
        icon: "ri-line-chart-line",
      },
      { text: "Tickets", path: "/ticket", icon: "ri-coupon-line" },
      { text: "Reports", path: "/Reports", icon: "ri-file-chart-line" },
      { text: "Log Reports", path: "/Log-Reports", icon: "ri-database-line" },
      {
        text: "Configuration",
        path: "/developer-configuration",
        icon: "ri-equalizer-line",
      },
    ];
  } else if (myrole == "customer") {
    return [
      {
        text: "Dashboard",
        path: "/customerDashboard",
        icon: "ri-line-chart-line",
      },
      { text: "Tickets", path: "/ticket", icon: "ri-coupon-line" },
      { text: "Contact", path: "/contact", icon: "ri-contacts-line" },
      {
        text: "Configuration",
        path: "/client-configuration",
        icon: "ri-equalizer-line",
      },
    ];
  } else if (myrole === "customercontact") {
    return [
      {
        text: "Dashboard",
        path: "/custContactDash",
        icon: "ri-line-chart-line",
      },
      { text: "Tickets", path: "/ticket", icon: "ri-coupon-line" },
      {
        text: "Configuration",
        path: "/contact-configuration",
        icon: "ri-equalizer-line",
      },
    ];
  }
}

function AuthProvider(props) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ INIT AUTH (ONLY CHANGE HERE)
  useEffect(() => {
    (async function () {
      try {
        // let auth = sessionStorage.getItem("authState");
        let auth = null;

        // ✅ wait until auth is available (max 300ms)
        for (let i = 0; i < 6; i++) {
          auth = sessionStorage.getItem("authState");

          if (auth) break;

          await new Promise((r) => setTimeout(r, 50));
        }

        if (!auth) {
          const localAuth = localStorage.getItem("authState");

          // ✅ ONLY restore if valid
          if (localAuth && isTokenValid(localAuth)) {
            sessionStorage.setItem("authState", localAuth);
            auth = sessionStorage.getItem("authState");
          } else {
            localStorage.removeItem("authState");
            sessionStorage.removeItem("authState");
            setUser(undefined);
            setLoading(false);
            return;
          }
        }

        // ✅ validate again before API
        if (!isTokenValid(auth)) {
          localStorage.removeItem("authState");
          sessionStorage.removeItem("authState");
          setUser(undefined);
          setLoading(false);
          return;
        }
        if (!sessionStorage.getItem("authState")) return;
        const result = await getUser();

        if (result.isOk) {
          const localUser = JSON.parse(localStorage.getItem("authState"));

          if (localUser?.email !== result.data.email) {
            localStorage.removeItem("authState");
            sessionStorage.removeItem("authState");
            setUser(undefined);
            window.location.replace("/");
            return;
          }

          let userAuth = RoleWiseAuth(result.data.userrole);

          setUser({
            ...result.data,
            userAuth: userAuth,
          });

          const role = result.data.userrole;
          const currentPath = location.pathname;

          if (currentPath === "/" || currentPath === "/login") {
            if (role === "company")
              navigate("/adminDashboard", { replace: true });
            else if (role === "companyuser")
              navigate("/developerDashboard", { replace: true });
            else if (role === "customer")
              navigate("/customerDashboard", { replace: true });
            else if (role === "customercontact")
              navigate("/custContactDash", { replace: true });
          }
        } else {
          localStorage.removeItem("authState");
          sessionStorage.removeItem("authState");
          setUser(undefined);
        }
      } catch (err) {
        localStorage.removeItem("authState");
        sessionStorage.removeItem("authState");
        setUser(undefined);
      }

      setLoading(false);
    })();
  }, []);

  // ✅ MULTI TAB SYNC (UNCHANGED)
  useEffect(() => {
    const handleStorageChange = async (event) => {
      if (event.key === "authState") {
        const auth = localStorage.getItem("authState");

        if (auth && isTokenValid(auth)) {
          sessionStorage.setItem("authState", auth);

          const result = await getUser();

          if (result.isOk) {
            let userAuth = RoleWiseAuth(result.data.userrole);

            setUser({
              ...result.data,
              userAuth: userAuth,
            });
          } else {
            localStorage.removeItem("authState");
            sessionStorage.removeItem("authState");
            setUser(undefined);
          }
        } else {
          sessionStorage.removeItem("authState");
          localStorage.removeItem("authState");
          setUser(undefined);
          window.location.replace("/");
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // ✅ SIGN IN (ONLY ADD VALIDATION BEFORE STORE)
  const signIn = useCallback(async (email, password) => {
    const existingAuth = localStorage.getItem("authState");

    if (existingAuth) {
      const existingUser = JSON.parse(existingAuth);

      if (existingUser.email !== email) {
        return {
          isOk: false,
          message:
            "Another user is already logged in this browser. Please logout first.",
        };
      }
    }

    const result = await sendSignInRequest(email, password);

    if (result.isOk) {
      setUser(result.data);
      let userAuth = RoleWiseAuth(result.data.userrole);

      setUser({
        ...result.data,
        userAuth: userAuth,
      });

      const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;

      const authData = {
        ...result.data,
        expirationTime,
      };

      const authString = JSON.stringify(authData);

      // ✅ ONLY STORE IF VALID
      if (isTokenValid(authString)) {
        localStorage.setItem("authState", authString);
        sessionStorage.setItem("authState", authString);
      }
    }

    return result;
  }, []);

  // ✅ SIGN OUT (UNCHANGED)
  const signOut = useCallback(() => {
    sessionStorage.removeItem("lastOpenedTicket");
    sessionStorage.removeItem("authState");
    localStorage.removeItem("authState");

    window.dispatchEvent(new Event("storage"));
    setUser(undefined);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        signIn,
        signOut,
        loading,
        setUser,
        unreadCount,
        setUnreadCount,
      }}
      {...props}
    />
  );
}

const AuthContext = createContext({ loading: false });
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
